import { auth } from '../firebase';
import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth';

const provider = new GoogleAuthProvider();

/**
 * Sign in with Google via popup.
 * Returns the Firebase user (with displayName, email, photoURL, uid) on success.
 * Throws on failure so callers can catch and display errors.
 */
export async function signInWithGoogle() {
  const credential = await signInWithPopup(auth, provider);
  return credential.user;
}
